import {
    boolYesNoType,
} from './commons';


const form = {
    title: "DD Gerente de Mercado",
    displayName: 'MarketManagerCaseReviewReport',
    page: 'market-manager-case-review-report',
    commentFieldsMap: {
        "Debida Diligencia Gerente de Mercado": "clients[0].retailClientDueDiligenceMarketManagerReport.dueDiligenceComments",
    },
    isSentBack(object) {
        return [
            "Devuelto",
            "Requerimiento de información adicional"
        ].indexOf(object.clients[0].retailClientDueDiligenceMarketManagerReport.dueDiligenceResult) !== -1;
    }
};

form.schema = {
    title: "Debida Diligencia - Gerente de Mercado",
    type: "object",
    properties: {
        "tipoPersona": {
            title: "Tipo de Persona - Gerente de Negocio",
            type: "number",
            readOnly: true,
            enum: [0, 1, 2, 3, 4],
            defaultValue: 0,
            'ui:hideDefault': true,
            enumNames: ["---", "Nacional", "Menores de Edad", "Extranjero Residente", "Extranjero No Residente"],
        },
        "tipoPersonaMM": {
            title: "Tipo de Persona - Gerente de Mercado",
            type: "number",
            enum: [0, 1, 2, 3, 4],
            defaultValue: 0,
            'ui:hideDefault': true,
            enumNames: ["---", "Nacional", "Menores de Edad", "Extranjero Residente", "Extranjero No Residente"],
        },
        "nivelRiesgo": {
            title: "Nivel de Riesgo - Gerente de Negocio",
            type: "number",
            readOnly: true,
            enumNames: ["---", "Alto", "Medio", "Bajo"],
            defaultValue: 0,
            'ui:hideDefault': true,
            enum: [0, 3, 2, 1],
        },
        "nivelRiesgoMM": {
            title: "Nivel de Riesgo - Gerente de Mercado",
            type: "number",
            enumNames: ["---", "Alto", "Medio", "Bajo"],
            defaultValue: 0,
            'ui:hideDefault': true,
            enum: [0, 3, 2, 1]
        },
        "perPoExp": {
            title: "Persona Políticamente Expuesta (PEP) - Gerente de Negocio",
            readOnly: true,
            ...boolYesNoType
        },
        "perPoExpMM": {
            title: "Persona Políticamente Expuesta (PEP) - Gerente de Mercado",
            ...boolYesNoType
        },
        "validacionDocumentosRequeridosMM": {
            title: "Validación de Documentos Requeridos",
            type: "object",
            properties: {
                "nacional": {
                    title: "Nacional - Gerente de Negocio",
                    type: "object",
                    readOnly: true,
                    properties: {
                        "copiaCedula": {
                            title: "Copia de cédula de Identidad y Electoral (ambos lados)",
                            type: "boolean",
                        },
                        "documentosFuenteIngresos": {
                            title: "Documentos que comprueben la fuente de ingresos",
                            type: "boolean",
                        },
                        "reporteInfoCredenticia": {
                            title: "Reporte de Información Crediticia",
                            type: "boolean",
                        },
                    },
                },
                "menoresEdad": {
                    title: "Menores de Edad - Gerente de Negocio",
                    type: "object",
                    readOnly: true,
                    properties: {
                        "cedulaIdentidadMenor": { title: "Copia de cédula de Identidad de menor", type: "boolean" },
                        "numUnicoIdentidad": { title: "Entre 14 y 17 años, Número Unico de Identidad (NIIU)", type: "boolean" },
                        "actaNacimiento": { title: "Acta de Nacimiento del Menor u otro documento que evidencie la relación con el menor", type: "boolean" },
                        "poderRepresentativo": { title: "Documento Legal donde el tutor legal otorga poder de representación", type: "boolean" },
                        "sentenciaAcreditada": { title: "Sentencia que acredita al representante como tutor", type: "boolean" }
                    },
                },
                "extranjeroResidente": {
                    title: "Extranjero Residente - Gerente de Negocio",
                    type: "object",
                    readOnly: true,
                    properties: {
                        "cedulaIdentidad": { title: "Copia de cédula de Identidad de residente permanente o temporal", type: "boolean" },
                        "pasaporteVigente": { title: "Pasaporte vigente, incluyendo sellos de entrada y salida", type: "boolean" },
                        "imagenIdentificacion": { title: "Imagen de una o más documentos de identificación de su país de origen", type: "boolean" },
                        "declaracionImpuesto": { title: "Declaración de Impuesto de su país de origen", type: "boolean" },
                        "fuenteIngresos": { title: "Documentos que comprueben la fuente de sus ingresos", type: "boolean" }
                    },
                },
                "extranjeroNoResidente": {
                    title: "Extranjero No Residente - Gerente de Negocio",
                    type: "object",
                    readOnly: true,
                    properties: {
                        "estatusMigratorio": { title: "Documento emitido por el Organismo Oficial correspondiente a su estatus migratorio", type: "boolean" },
                        "pasaporteVigente": { title: "Pasaporte vigente, incluyendo sellos de entrada y salida", type: "boolean" },
                        "imagenIdentificacion": { title: "Imagen de una o más documentos de identificación de su país de origen", type: "boolean" },
                        "declaracionImpuesto": { title: "Declaración de Impuesto de su país de origen", type: "boolean" },
                        "fuenteIngresos": { title: "Documentos que comprueben la fuente de sus ingresos", type: "boolean" }
                    },
                },
                "nacionalMM": {
                    title: "Nacional - Gerente de Mercado",
                    type: "object",
                    properties: {
                        "copiaCedula": {
                            title: "Copia de cédula de Identidad y Electoral (ambos lados)",
                            type: "boolean",
                        },
                        "documentosFuenteIngresos": {
                            title: "Documentos que comprueben la fuente de ingresos",
                            type: "boolean",
                        },
                        "reporteInfoCredenticia": {
                            title: "Reporte de Información Crediticia",
                            type: "boolean",
                        },
                    },
                },
                "menoresEdadMM": {
                    title: "Menores de Edad - Gerente de Mercado",
                    type: "object",
                    properties: {
                        "cedulaIdentidadMenor": { title: "Copia de cédula de Identidad de menor", type: "boolean" },
                        "numUnicoIdentidad": { title: "Entre 14 y 17 años, Número Unico de Identidad (NIIU)", type: "boolean" },
                        "actaNacimiento": { title: "Acta de Nacimiento del Menor u otro documento que evidencie la relación con el menor", type: "boolean" },
                        "poderRepresentativo": { title: "Documento Legal donde el tutor legal otorga poder de representación", type: "boolean" },
                        "sentenciaAcreditada": { title: "Sentencia que acredita al representante como tutor", type: "boolean" }
                    },
                },
                "extranjeroResidenteMM": {
                    title: "Extranjero Residente - Gerente de Mercado",
                    type: "object",
                    properties: {
                        "cedulaIdentidad": { title: "Copia de cédula de Identidad de residente permanente o temporal", type: "boolean" },
                        "pasaporteVigente": { title: "Pasaporte vigente, incluyendo sellos de entrada y salida", type: "boolean" },
                        "imagenIdentificacion": { title: "Imagen de una o más documentos de identificación de su país de origen", type: "boolean" },
                        "declaracionImpuesto": { title: "Declaración de Impuesto de su país de origen", type: "boolean" },
                        "fuenteIngresos": { title: "Documentos que comprueben la fuente de sus ingresos", type: "boolean" }
                    },
                },
                "extranjeroNoResidenteMM": {
                    title: "Extranjero No Residente - Gerente de Mercado",
                    type: "object",
                    properties: {
                        "estatusMigratorio": { title: "Documento emitido por el Organismo Oficial correspondiente a su estatus migratorio", type: "boolean" },
                        "pasaporteVigente": { title: "Pasaporte vigente, incluyendo sellos de entrada y salida", type: "boolean" },
                        "imagenIdentificacion": { title: "Imagen de una o más documentos de identificación de su país de origen", type: "boolean" },
                        "declaracionImpuesto": { title: "Declaración de Impuesto de su país de origen", type: "boolean" },
                        "fuenteIngresos": { title: "Documentos que comprueben la fuente de sus ingresos", type: "boolean" }
                    },
                },
            }
        },
        "beneficiarioFinalMM": {
            title: "Beneficiario Final",
            type: "object",
            properties: {
                "identificacionBeneficiarioFinal": {
                    title: "Identificación de Beneficiario Final - Gerente de Negocio",
                    type: "number",
                    enum: [0, 1, 2, 3],
                    readOnly: true,
                    defaultValue: 0,
                    'ui:hideDefault': true,
                    enumNames: ["---", "Si", "No", "No Aplica- Cliente es el único beneficiario"],
                },
                "identificacionBeneficiarioFinalMM": {
                    title: "Identificación de Beneficiario Final - Gerente de Mercado",
                    type: "number",
                    enum: [0, 1, 2, 3],
                    'ui:hideDefault': true,
                    enumNames: ["---", "Si", "No", "No Aplica- Cliente es el único beneficiario"],
                },
            },
            // required: ["identificacionBeneficiarioFinalMM"]
        },
        "procedenciaDestinoFondosMM": {
            title: "Procedencia y destino de Fondos",
            type: "object",
            properties: {
                "origenFondos": {
                    title: "Origen de los Fondos - Gerente de Negocio",
                    readOnly: true,
                    ...boolYesNoType
                },
                "origenFondosMM": {
                    title: "Origen de los Fondos - Gerente de Mercado",
                    ...boolYesNoType
                },
                "destinoFondos": {
                    title: "Destino de Fondos - Gerente de Negocio",
                    type: "number",
                    enum: [0, 1, 2, 3],
                    defaultValue: 0,
                    readOnly: true,
                    'ui:hideDefault': true,
                    enumNames: ["---", "Si", "No", "No Aplica"],
                },
                "destinoFondosMM": {
                    title: "Destino de Fondos - Gerente de Mercado",
                    type: "number",
                    enum: [0, 1, 2, 3],
                    'ui:hideDefault': true,
                    enumNames: ["---", "Si", "No", "No Aplica"],
                },

            },
            required: ["origenFondosMM", "destinoFondosMM"],
        },
        "validacionAnexosMM": {
            title: "Validación de anexos",
            type: "object",
            properties: {
                "consultasListas": { title: "Consultas en Listas - Gerente de Negocio", type: "boolean", readOnly: true },
                "matrizRiesgo": { title: "Matriz de Riesgo - Gerente de Negocio", type: "boolean", readOnly: true },
                "consultasListasMM": { title: "Consultas en Listas - Gerente de Mercado", type: "boolean" },
                "matrizRiesgoMM": { title: "Matriz de Riesgo - Gerente de Mercado", type: "boolean" }
            },
            required: ["consultasListasMM", "matrizRiesgoMM"],
        },
        "debDilGerNeg": {
            title: "Debida Diligencia Gerente de Negocios - Gerente de Negocio",
            readOnly: true,
            type: "object",
            properties: {
                "obsGerNeg": {
                    title: "Observaciones Gerente de Negocios",
                    type: "string"
                },
                "fechaRevision": {
                    title: "Fecha de revisión",
                    type: "string",
                    format: "date"
                },
                "resDebDil": {
                    title: "Resultado Debida Diligencia",
                    type: "string",
                    enum: [
                        "Aprobado",
                        "Rechazado",
                        "Aprobado con excepción",
                        "Devuelto",
                        "Requerimiento de información adicional"
                    ]
                },
                "comentarios": {
                    title: "Comentarios",
                    type: "string"
                },
                "razonDevolucion": {
                    title: "Razón de Devolución",
                    type: ["string", "null"],
                    enum: [
                        null,
                        "Documento cargado no cumple con requerimientos",
                        "Documento o información faltante",
                        "Error en digitación de información",
                        "Información Incorrecta",
                        "Otros"
                    ],
                    enumNames: [
                        "---",
                        "Documento cargado no cumple con requerimientos",
                        "Documento o información faltante",
                        "Error en digitación de información",
                        "Información Incorrecta",
                        "Otros"
                    ],
                },
            }
        },
        "debDilGerNegMM": {
            title: "Debida Diligencia - Gerente de Mercado",
            type: "object",
            properties: {
                "obsGerNegMM": {
                    title: "Observaciones",
                    type: "string"
                },
                "fechaRevisionMM": {
                    title: "Fecha de revisión",
                    type: "string",
                    format: "date"
                },
                "resDebDilMM": {
                    title: "Resultado Debida Diligencia",
                    type: "string",
                    enum: [
                        "Aprobado",
                        "Rechazado",
                        "Aprobado con excepción",
                        "Devuelto",
                        "Requerimiento de información adicional"
                    ]
                },
                "comentariosMM": {
                    title: "Comentarios",
                    type: "string"
                },
                "razonDevolucionMM": {
                    title: "Razón de Devolución",
                    type: "string",
                    enum: ["Documento cargado no cumple con requerimientos",
                        "Documento o información faltante",
                        "Error en digitación de información",
                        "Información Incorrecta",
                        "Otros"
                    ],
                },
            },
            required: ["obsGerNegMM", "fechaRevisionMM", "resDebDilMM"],
        },
        "tipoCliente": {
            title: "Tipo de Cliente - Gerente de Negocio",
            type: "number",
            enum: [0, 1, 2],
            readOnly: true,
            defaultValue: 0,
            'ui:hideDefault': true,
            enumNames: ["---", "Persona Física", "Persona Jurídica"],
        },
        "tipoClienteMM": {
            title: "Tipo de Cliente - Gerente de Mercado",
            type: "number",
            enum: [0, 1, 2],
            'ui:hideDefault': true,
            enumNames: ["---", "Persona Física", "Persona Jurídica"],
        },
    },
    // required: ["tipoPersonaMM", "nivelRiesgoMM"],
};

form.uiSchema = {
    "ui:field": "HideObjectField",
    "ui:className": "hideObjectField_title",
    "tipoPersonaMM": {
        "akc:validate": {
            "expr": "$value = 0 ? 'es requerido' : null"
        },
    },
    "nivelRiesgoMM": {
        "akc:validate": {
            "expr": "$value = 0 ? 'es requerido' : null"
        },
    },
    "tipoPersona": {
        "ui:showIf": {
            expr: "$formObject != null ? $fromJson($formObject.state).`requiresApproval.manager` : false"
        }
    },
    "tipoCliente": {
        "ui:showIf": {
            expr: "$formObject != null ? $fromJson($formObject.state).`requiresApproval.manager` : false"
        }
    },
    "validacionDocumentosRequeridosMM": {
        "ui:field": "HideObjectField",
        "ui:className": "hideObjectField_title",
        "nacional": {
            "ui:widget": "checkboxes",
            "ui:showIf": { expr: 'tipoPersona = 1' },
        },
        "nacionalMM": {
            "ui:widget": "checkboxes",
            "ui:showIf": { expr: 'tipoPersonaMM = 1' },
        },
        "menoresEdad": {
            "ui:widget": "checkboxes",
            "ui:showIf": { expr: 'tipoPersona = 2' },
        },
        "menoresEdadMM": {
            "ui:widget": "checkboxes",
            "ui:showIf": { expr: 'tipoPersonaMM = 2' },
        },
        "extranjeroResidente": {
            "ui:widget": "checkboxes",
            "ui:showIf": { expr: 'tipoPersona = 3' },
        },
        "extranjeroResidenteMM": {
            "ui:widget": "checkboxes",
            "ui:showIf": { expr: 'tipoPersonaMM = 3' },
        },
        "extranjeroNoResidente": {
            "ui:widget": "checkboxes",
            "ui:showIf": { expr: 'tipoPersona = 4' },
        },
        "extranjeroNoResidenteMM": {
            "ui:widget": "checkboxes",
            "ui:showIf": { expr: 'tipoPersonaMM = 4' },
        },
    },
    "nivelRiesgo": { "ui:showIf": "$formObject != null ? $fromJson($formObject.state).`requiresApproval.manager` : false" },
    "perPoExp": { "ui:showIf": "$formObject != null ? $fromJson($formObject.state).`requiresApproval.manager` : false" },
    "beneficiarioFinalMM": {
        "ui:className": "hideObjectField_title",
        "ui:field": "HideObjectField",
        "identificacionBeneficiarioFinalMM": {
            "akc:validate": {
                "expr": "$value = 0 ? 'es requerido' : null"
            },
        },
        "identificacionBeneficiarioFinal": {
            "ui:showIf": {
                expr: "$formObject != null ? $fromJson($formObject.state).`requiresApproval.manager` : false"
            }
        }
    },
    "procedenciaDestinoFondosMM": {
        "ui:className": "hideObjectField_title",
        "ui:field": "HideObjectField",
        "origenFondos": {
            "ui:widget": "radio",
            "ui:options": {
                inline: true
            },
            "ui:showIf": {
                expr: "$formObject != null ? $fromJson($formObject.state).`requiresApproval.manager` : false"
            }
        },
        "origenFondosMM": {
            "ui:widget": "radio",
            "ui:options": {
                inline: true
            },
        },
        "destinoFondos": {
            "ui:showIf": {
                expr: "$formObject != null ? $fromJson($formObject.state).`requiresApproval.manager` : false"
            }
        },
        "destinoFondosMM": {
            "akc:validate": {
                "expr": "$value = 0 ? 'es requerido' : null"
            },
        },
    },
    "validacionAnexosMM": {
        "ui:className": "hideObjectField_title",
        "ui:field": "HideObjectField",
        "consultasListas": {
            "ui:showIf": {
                expr: "$formObject != null ? $fromJson($formObject.state).`requiresApproval.manager` : false"
            }
        },
        "matrizRiesgo": {
            "ui:showIf": {
                expr: "$formObject != null ? $fromJson($formObject.state).`requiresApproval.manager` : false"
            }
        }
    },
    "debDilGerNegMM": {
        "ui:className": "hideObjectField_title",
        "ui:field": "HideObjectField",
        "obsGerNegMM": {
            "ui:widget": "textarea",
            "ui:options": {
                rows: 4
            },
        },
        "comentariosMM": {
            "ui:widget": "textarea",
            "ui:options": {
                rows: 4
            },
        },
        "razonDevolucionMM": {
            "ui:showIf": {
                expr: "debDilGerNegMM.resDebDilMM = 'Devuelto' ? 'es requerido' : ''"
            },
        }
    },
    "debDilGerNeg": {
        "ui:field": "HideObjectField",
        "ui:className": "hideObjectField_title",
        "ui:showIf": "$formObject != null ? $fromJson($formObject.state).`requiresApproval.manager` : false",
        "obsGerNeg": {
            "ui:widget": "textarea",
            "ui:options": {
                rows: 4
            },
        },
        "comentarios": {
            "ui:widget": "textarea",
            "ui:options": {
                rows: 4
            },
        },
        "razonDevolucion": {
            "ui:showIf": {
                expr: "debDilGerNeg.resDebDil = 'Devuelto' ? 'es requerido' : ''"
            },
        }
    }
}


form.objectMap = {
    "clients[0].retailClientDueDiligenceReport.personType": "tipoPersona",
    "clients[0].retailClientDueDiligenceMarketManagerReport.personType": "tipoPersonaMM",
    "clients[0].retailClientDueDiligenceReport.clientType": "tipoCliente",
    "clients[0].retailClientDueDiligenceMarketManagerReport.clientType": "tipoClienteMM",
    "clients[0].retailClientDueDiligenceReport.riskLevel": "nivelRiesgo",
    "clients[0].retailClientDueDiligenceMarketManagerReport.riskLevel": "nivelRiesgoMM",
    "clients[0].retailClientPoliticalExposureInfo.hasPoliticalExposure": "perPoExp",
    "clients[0].retailClientDueDiligenceMarketManagerReport.hasPoliticalExposure": "perPoExpMM",

    "clients[0].retailClientDueDiligenceReport.nationalCopyOfId": "validacionDocumentosRequeridosMM.nacional.copiaCedula", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.nationalCopyOfId": "validacionDocumentosRequeridosMM.nacionalMM.copiaCedula", // true
    "clients[0].retailClientDueDiligenceReport.nationalIncomeDocument": "validacionDocumentosRequeridosMM.nacional.documentosFuenteIngresos", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.nationalIncomeDocument": "validacionDocumentosRequeridosMM.nacionalMM.documentosFuenteIngresos", // true
    "clients[0].retailClientDueDiligenceReport.nationalSecondFormOfId": "validacionDocumentosRequeridosMM.nacional.segundaIdentificacion", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.nationalSecondFormOfId": "validacionDocumentosRequeridosMM.nacionalMM.segundaIdentificacion", // true
    "clients[0].retailClientDueDiligenceReport.nationalCreditReport": "validacionDocumentosRequeridosMM.nacional.reporteInfoCredenticia", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.nationalCreditReport": "validacionDocumentosRequeridosMM.nacionalMM.reporteInfoCredenticia", // true

    "clients[0].retailClientDueDiligenceReport.residentAlienCopyOfResidenceCard": "validacionDocumentosRequeridosMM.extranjeroResidente.cedulaIdentidad", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.residentAlienCopyOfResidenceCard": "validacionDocumentosRequeridosMM.extranjeroResidenteMM.cedulaIdentidad", // true
    "clients[0].retailClientDueDiligenceReport.residentAlienCopyOfPassport": "validacionDocumentosRequeridosMM.extranjeroResidente.pasaporteVigente", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.residentAlienCopyOfPassport": "validacionDocumentosRequeridosMM.extranjeroResidenteMM.pasaporteVigente", // true
    "clients[0].retailClientDueDiligenceReport.residentAlienNationalityId": "validacionDocumentosRequeridosMM.extranjeroResidente.imagenIdentificacion", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.residentAlienNationalityId": "validacionDocumentosRequeridosMM.extranjeroResidenteMM.imagenIdentificacion", // true
    "clients[0].retailClientDueDiligenceReport.residentAlienCountryOfOriginTaxes": "validacionDocumentosRequeridosMM.extranjeroResidente.declaracionImpuesto", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.residentAlienCountryOfOriginTaxes": "validacionDocumentosRequeridosMM.extranjeroResidenteMM.declaracionImpuesto", // true
    "clients[0].retailClientDueDiligenceReport.residentAlientIncomeReport": "validacionDocumentosRequeridosMM.extranjeroResidente.fuenteIngresos", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.residentAlientIncomeReport": "validacionDocumentosRequeridosMM.extranjeroResidente.MMfuenteIngresos", // true

    "clients[0].retailClientDueDiligenceReport.underageCopyOfId": "validacionDocumentosRequeridosMM.menoresEdad.cedulaIdentidadMenor", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.underageCopyOfId": "validacionDocumentosRequeridosMM.menoresEdadMM.cedulaIdentidadMenor", // true
    "clients[0].retailClientDueDiligenceReport.underageNIIU": "validacionDocumentosRequeridosMM.menoresEdad.numUnicoIdentidad", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.underageNIIU": "validacionDocumentosRequeridosMM.menoresEdadMM.numUnicoIdentidad", // true
    "clients[0].retailClientDueDiligenceReport.underageBirthCertificate": "validacionDocumentosRequeridosMM.menoresEdad.actaNacimiento", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.underageBirthCertificate": "validacionDocumentosRequeridosMM.menoresEdadMM.actaNacimiento", // true
    "clients[0].retailClientDueDiligenceReport.underagePowerOfAttorney": "validacionDocumentosRequeridosMM.menoresEdad.poderRepresentativo", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.underagePowerOfAttorney": "validacionDocumentosRequeridosMM.menoresEdadMM.poderRepresentativo", // true
    "clients[0].retailClientDueDiligenceReport.underageTutorRepresentation": "validacionDocumentosRequeridosMM.menoresEdad.sentenciaAcreditada", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.underageTutorRepresentation": "validacionDocumentosRequeridosMM.menoresEdadMM.sentenciaAcreditada", // true

    "clients[0].retailClientDueDiligenceReport.nonResidentAlienCopyOfResidenceCard": "validacionDocumentosRequeridosMM.extranjeroNoResidente.estatusMigratorio", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.nonResidentAlienCopyOfResidenceCard": "validacionDocumentosRequeridosMM.extranjeroNoResidenteMM.estatusMigratorio", // true
    "clients[0].retailClientDueDiligenceReport.nonResidentAlienCopyOfPassport": "validacionDocumentosRequeridosMM.extranjeroNoResidente.pasaporteVigente", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.nonResidentAlienCopyOfPassport": "validacionDocumentosRequeridosMM.extranjeroNoResidenteMM.pasaporteVigente", // true
    "clients[0].retailClientDueDiligenceReport.nonResidentAlienNationalityId": "validacionDocumentosRequeridosMM.extranjeroNoResidente.imagenIdentificacion", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.nonResidentAlienNationalityId": "validacionDocumentosRequeridosMM.extranjeroNoResidenteMM.imagenIdentificacion", // true
    "clients[0].retailClientDueDiligenceReport.nonResidentAlienCountryOfOriginTaxes": "validacionDocumentosRequeridosMM.extranjeroNoResidente.declaracionImpuesto", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.nonResidentAlienCountryOfOriginTaxes": "validacionDocumentosRequeridosMM.extranjeroNoResidenteMM.declaracionImpuesto", // true
    "clients[0].retailClientDueDiligenceReport.nonResidentAlientIncomeReport": "validacionDocumentosRequeridosMM.extranjeroNoResidente.fuenteIngresos", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.nonResidentAlientIncomeReport": "validacionDocumentosRequeridosMM.extranjeroNoResidenteMM.fuenteIngresos", // true

    "clients[0].retailClientDueDiligenceReport.finalBeneficiary": "beneficiarioFinalMM.identificacionBeneficiarioFinal",
    "clients[0].retailClientDueDiligenceMarketManagerReport.finalBeneficiary": "beneficiarioFinalMM.identificacionBeneficiarioFinalMM",

    "clients[0].retailClientDueDiligenceReport.isFundsOrigin": "procedenciaDestinoFondosMM.origenFondos", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.isFundsOrigin": "procedenciaDestinoFondosMM.origenFondosMM", // true
    "clients[0].retailClientDueDiligenceReport.fundsDestination": "procedenciaDestinoFondosMM.destinoFondos",// must be number
    "clients[0].retailClientDueDiligenceMarketManagerReport.fundsDestination": "procedenciaDestinoFondosMM.destinoFondosMM",// must be number

    "clients[0].retailClientDueDiligenceReport.anexedListConsultations": "validacionAnexosMM.consultasListas", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.anexedListConsultations": "validacionAnexosMM.consultasListasMM", // true
    "clients[0].retailClientDueDiligenceReport.anexedRiskMatrix": "validacionAnexosMM.matrizRiesgo", // true
    "clients[0].retailClientDueDiligenceMarketManagerReport.anexedRiskMatrix": "validacionAnexosMM.matrizRiesgoMM", // true

    "clients[0].retailClientDueDiligenceReport.bussinesManagerObservations": "debDilGerNeg.obsGerNeg",
    "clients[0].retailClientDueDiligenceMarketManagerReport.bussinesManagerObservations": "debDilGerNegMM.obsGerNegMM",
    "clients[0].retailClientDueDiligenceReport.revisionDate": "debDilGerNeg.fechaRevision",
    "clients[0].retailClientDueDiligenceMarketManagerReport.revisionDate": "debDilGerNegMM.fechaRevisionMM",
    "clients[0].retailClientDueDiligenceReport.dueDiligenceResult": "debDilGerNeg.resDebDil",
    "clients[0].retailClientDueDiligenceMarketManagerReport.dueDiligenceResult": "debDilGerNegMM.resDebDilMM",
    "clients[0].retailClientDueDiligenceReport.dueDiligenceComments": "debDilGerNeg.comentarios",
    "clients[0].retailClientDueDiligenceMarketManagerReport.dueDiligenceComments": "debDilGerNegMM.comentariosMM",
    "clients[0].retailClientDueDiligenceReport.sendBackReason": "debDilGerNeg.razonDevolucion",
    "clients[0].retailClientDueDiligenceMarketManagerReport.sendBackReason": "debDilGerNegMM.razonDevolucionMM",

}


export default form;